import React from 'react';
import { motion } from 'framer-motion';

const Features = () => {
  const features = [
    {
      icon: 'fas fa-desktop',
      tag: 'Web Platform',
      title: 'Admin Dashboard',
      description: 'Comprehensive management system with real-time analytics and powerful reporting tools.',
      features: ['Real-time Analytics', 'Student Management', 'Advanced Reports'],
      link: 'Learn More',
      linkIcon: 'fas fa-arrow-right'
    },
    {
      icon: 'fas fa-mobile-alt',
      tag: 'Mobile App',
      title: 'Parent Mobile App',
      description: 'Native Android app keeping parents connected with their child\'s educational journey.',
      features: ['Progress Tracking', 'Attendance Monitor', 'Direct Communication'],
      link: 'Download App',
      linkIcon: 'fas fa-download',
      featured: true
    },
    {
      icon: 'fas fa-chalkboard-teacher',
      tag: 'Faculty Portal',
      title: 'Teacher Dashboard',
      description: 'Dedicated portal for teachers to manage classes and track student performance efficiently.',
      features: ['Class Management', 'Assignment Tracking', 'Performance Reports'],
      link: 'Explore Features',
      linkIcon: 'fas fa-arrow-right'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="features">
      <div className="features-container">
        <motion.div 
          className="section-header"
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="section-badge">
            <span className="badge-icon">⚡</span>
            Complete Platform
          </div>
          <h2 className="section-title">
            Everything Your School Needs
            <span className="title-highlight"> In One Place</span>
          </h2>
          <p className="section-subtitle">
            Powerful features designed for modern educational institutions
          </p>
        </motion.div>
        
        <motion.div 
          className="features-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className={`feature-card ${feature.featured ? 'featured' : ''}`}
              variants={cardVariants}
              whileHover={{ 
                y: -10,
                transition: { duration: 0.3 }
              }}
            >
              {feature.featured && (
                <div className="featured-tag">Most Popular</div>
              )}
              
              <div className="card-header">
                <motion.div 
                  className="card-icon"
                  whileHover={{ scale: 1.1 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <i className={feature.icon}></i>
                </motion.div>
                <div className="card-tag">{feature.tag}</div>
              </div>
              
              <div className="card-body">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                <ul className="card-features">
                  {feature.features.map((item, idx) => (
                    <motion.li
                      key={idx}
                      initial={{ x: -20, opacity: 0 }}
                      whileInView={{ x: 0, opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.1 * idx }}
                    >
                      <i className="fas fa-check-circle"></i> {item}
                    </motion.li>
                  ))}
                </ul>
              </div>
              
              <div className="card-footer">
                <motion.a 
                  href="#" 
                  className="card-link"
                  whileHover={{ x: 5 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  {feature.link} <i className={feature.linkIcon}></i>
                </motion.a>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;